var UnitEnum = /* @__PURE__ */ ((UnitEnum2) => {
  UnitEnum2["percent"] = "%";
  UnitEnum2["pixel"] = "px";
  return UnitEnum2;
})(UnitEnum || {});
var OverlayType = /* @__PURE__ */ ((OverlayType2) => {
  OverlayType2["color"] = "color";
  OverlayType2["gradient"] = "gradient";
  return OverlayType2;
})(OverlayType || {});
var ColorType = /* @__PURE__ */ ((ColorType2) => {
  ColorType2["solid"] = "solid";
  ColorType2["gradient"] = "gradient";
  return ColorType2;
})(ColorType || {});
var GradientType = /* @__PURE__ */ ((GradientType2) => {
  GradientType2["linear"] = "linear";
  GradientType2["radial"] = "radial";
  return GradientType2;
})(GradientType || {});
var Alignment = /* @__PURE__ */ ((Alignment2) => {
  Alignment2["left"] = "left";
  Alignment2["center"] = "center";
  Alignment2["right"] = "right";
  Alignment2["justify"] = "justify";
  return Alignment2;
})(Alignment || {});
var VerticalAlignment = /* @__PURE__ */ ((VerticalAlignment2) => {
  VerticalAlignment2["top"] = "top";
  VerticalAlignment2["center"] = "center";
  VerticalAlignment2["bottom"] = "bottom";
  return VerticalAlignment2;
})(VerticalAlignment || {});

export { Alignment, ColorType, GradientType, OverlayType, UnitEnum, VerticalAlignment };
